function get_top(element) {
    Rails.ajax({
        url: "/ujs/top_" + element,
        type: "PATCH",
        success: function(data) {
        },
        error: function(error) {
        }
    });
};

async function get_tops() {
    // for (const e of ["ip_addresses", "phone_numbers", "scamalyzer_codes", "email_addresses", "ceacs"]) {
    //     await get_top(e);
    // }
    const promises = [];
    
    for (const e of ["ip_addresses", "phone_numbers", "email_addresses", "ceacs"]) {
         promises.push(get_top(e));
    }
    
    await Promise.all(promises);

    
    // await get_top("ip_addresses");
    // await get_top("phone_numbers");
    // //await get_top("scamalyzer_codes");
    // await get_top("email_addresses");
    // await get_top("ceacs");
    
}

function change_country(event) {
    // this is the way
    Rails.ajax({
        url: "/ujs/change_country",
        type: "PATCH",
        data: "country=" + event.target.value,
        success: function(data) {
            get_tops();
        }
    });
};

function change_time_period(event) {
    // Persist the new period to the session, then refresh all top item tables.
    Rails.ajax({
        url: "/ujs/change_time_period",
        type: "PATCH",
        data: "time_period=" + event.target.value,
        success: function(data) {
            get_tops();
        }
    });
};

// Null-check both elements: these dropdowns only exist on the dashboard, so other
// pages that include this pack won't throw a TypeError on missing elements.
var countryEl = document.querySelector("#country_name");
if (countryEl) {
    countryEl.addEventListener("change", function(event) {
        change_country(event);
    });
}

var timePeriodEl = document.querySelector("#time_period");
if (timePeriodEl) {
    timePeriodEl.addEventListener("change", function(event) {
        change_time_period(event);
    });
}

get_tops();

//ATLP-5485
//document.querySelector("#top_ip_addresses").innerHTML("");
